import * as type from '../actions/types';

const initialState = {
    available: [],
    loading: false,
    error: null,
}

export default function projectsAvailableData(state = initialState, action) {
    switch (action.type) {
        case type.GET_PROJECTS_AVAILABLE_DATA_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_PROJECTS_AVAILABLE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                available: action.data.web_available_projects,
            }
        case type.GET_PROJECTS_AVAILABLE_DATA_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}